import React, { PureComponent } from 'react';
import { IntlProps, addTranslation } from 'decorators/addTranslation';

import Button from 'components/ui/button';
import Panel from 'components/ui/panel';
import Form from 'components/ui/form';
import SelectionList from 'components/ui/selectionList';
import Input from 'components/ui/input';
import RadioGroup from 'components/ui/radioGroup';
import Radio from 'components/ui/radio';
import Loader from 'components/ui/loader';
import ListTypes from 'pages/risks/components/addtoList/single/ListTypes';
import { checkSelectedRcsProjects } from 'pages/risks/helpers';
import ConfigType from './configType';
import { WL_ID_19 } from 'constants/wlIds';

interface Props extends IntlProps {
  isOpened: boolean;
  isLoadingTypes: boolean;
  isShowBinTooltip: boolean;
  isLoading: boolean;
  reasonValue: any;
  listType: string;
  projectList: any[];
  onOpen: () => void;
  onClose: () => void;
  onSend: (data) => void;
  onChange: (name: string, data) => void;
  config: ConfigType;
  wlId?: number | null
}

class AddBlackList extends PureComponent<Props> {
  render() {
    const { onOpen, isLoadingTypes, getTranslate } = this.props;
    return (
      <div className='relative add-blacklist'>
        <Button
          id='button-open-backList-panel'
          text={getTranslate('risks.addToList.list')}
          status='primary'
          size='normal'
          onClick={onOpen}
          loading={isLoadingTypes}
        />
        {this.renderPanel()}
      </div>
    );
  }

  renderPanel = () => {
    const {
      isLoading,
      isOpened,
      reasonValue,
      listType,
      projectList,
      config,
      onClose,
      onSend,
      onChange,
      getTranslate,
      isShowBinTooltip,
      wlId
    } = this.props;
    const hasWhitelistAccess = config['whitelist'].contentTypes.length;

    return (
      <Panel
        id='add-black-list-panel'
        isOpened={isOpened}
        onClose={onClose}
        title={getTranslate('risks.addToList.list')}
        customClass='ui-panel_add-black-list add-blacklist__panel'
        modern>
        <Form onSubmit={onSend}>
          {isLoading && <Loader />}
          <div className='border-border-base border-t p-5 add-blacklist__body'>
            <div className='mb-4 add-blacklist__hint'>
              {getTranslate(
                isShowBinTooltip
                  ? 'payment.addToListBIN.tooltip'
                  : 'payment.addToList.tooltip'
              )}
            </div>
            <div className='mb-4 add-blacklist__row add-blacklist__radio-row'>
              <RadioGroup
                customClass='ui-radio-group_row add-blacklist__radio-group'
                onChange={(value) => onChange('listType', value)}
                checkedId={listType}>
                <Radio
                  id={ListTypes.blackList}
                  text={getTranslate('risks.addToList.list.black')}
                />
                <Radio
                  id={ListTypes.whiteList}
                  text={getTranslate('risks.addToList.list.white')}
                  isDisabled={!hasWhitelistAccess}
                  infoIcon={
                    !hasWhitelistAccess
                      ? getTranslate('risks.addToList.whitelist.access.tooltip')
                      : undefined
                  }
                />
              </RadioGroup>
            </div>
            <div className='mb-4 add-blacklist__row add-blacklist__field add-blacklist__content-types'>
              <SelectionList
                label={getTranslate('payment.addToList.category')}
                items={config[listType].contentTypes}
                isSearchable={false}
                isLoading={isLoading}
                onChange={(items) => onChange('contentTypes', items)}
                modern
                applyOnClose={wlId === WL_ID_19}
              />
            </div>
            <div className='mb-4 add-blacklist__row add-blacklist__field add-blacklist__projects'>
              <SelectionList
                label={getTranslate('payment.addToList.project')}
                items={projectList}
                onChange={(items) => onChange('projectList', items)}
                isValidBeforeApply={checkSelectedRcsProjects}
                applyOnClose={wlId === WL_ID_19}
                modern
              />
            </div>
            <div className='add-blacklist__row add-blacklist__field'>
              <Input
                type='textarea'
                resize={false}
                id='blacklist-reason'
                label={getTranslate('payment.addToList.reason')}
                value={reasonValue}
                placeholder={getTranslate(
                  'risks.quickFilters.value.placeholder'
                )}
                onChange={(e) => onChange('reasonValue', e.target.value)}
                modern
              />
            </div>
          </div>
          <div className='border-border-base border-t p-5 add-blacklist__footer'>
            <Button
              type='submit'
              status='primary'
              text={getTranslate('common.apply.button')}
              customClass='ui-button_full-width add-blacklist__submit'
            />
          </div>
        </Form>
      </Panel>
    );
  };
}

export default addTranslation(AddBlackList);
